var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: props.fill
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.125a.75.75 0 00.75-.75V1.5a.75.75 0 10-1.5 0v1.875a.75.75 0 00.75.75zM12 18.375a6.375 6.375 0 100-12.75 6.375 6.375 0 000 12.75zM5.614 6.595a.75.75 0 01-.243-.163L4.045 5.106a.75.75 0 111.06-1.06L6.433 5.37a.75.75 0 01-.818 1.224zM4.125 12a.75.75 0 00-.75-.75H1.5a.75.75 0 100 1.5h1.875a.75.75 0 00.75-.75zM4.045 18.894l1.326-1.325a.752.752 0 011.225.242.75.75 0 01-.164.818l-1.326 1.326a.751.751 0 11-1.06-1.06zM12 19.875a.75.75 0 00-.75.75V22.5a.75.75 0 101.5 0v-1.875a.75.75 0 00-.75-.75zM18.386 17.405a.753.753 0 01.243.163l1.326 1.326a.75.75 0 11-1.06 1.06l-1.326-1.325a.753.753 0 01-.002-1.062.748.748 0 01.819-.162zM22.5 11.25h-1.875a.75.75 0 100 1.5H22.5a.75.75 0 100-1.5zM18.386 6.594a.748.748 0 01-.98-.406.75.75 0 01.163-.817l1.325-1.326a.75.75 0 111.06 1.06L18.63 6.433a.748.748 0 01-.243.162z"
  }))));
}

export default SvgSun;